import { render, staticRenderFns } from "./SectionIntroduction.vue?vue&type=template&id=936053f2"
import script from "./SectionIntroduction.vue?vue&type=script&lang=js"
export * from "./SectionIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports